import { Dropdown, Modal, Tooltip } from "bootstrap";

/**
 * Setups up modal, scroll up, datepicker, select2
 * with timeout as
 */
export function setupJavascript() {
  setUpModal();
  setupScrollUp();
  setSessionMessage();
  window.initDatepicker();
  window.initSelect2();
  initTooltips();

  const navTabs = document.querySelectorAll(".nav.nav-tabs");
  if (navTabs.length > 0) {
    navTabs.forEach(el => {
      if (
        el.querySelector(".nav-link.active") ||
        (window.location.hash &&
          document.querySelector(
            /* format: xxx-'name here to open tab'*/
            `a.nav-link[href="#${window.location.hash.split("-")[1]}"]`
          ))
      ) {
        /**
         * If there is a nav-tabs with.active class, skip or if hash exists and tab nav found,
         * skip. (Should be handled in its respective controller, e.g people and marking_sheets controller)
         */
        return;
      }

      const navLink = el.querySelector(".nav-link");
      if (navLink) navLink.click();
    });
  }

  document.querySelectorAll(`.dropdown-toggle`).forEach(el => {
    new Dropdown(el, {
      boundary: "window"
    });
  });

  document.querySelectorAll(`[data-confirm]`).forEach(el => {
    el.addEventListener(
      "click",
      evt => {
        evt.preventDefault();
        evt.stopPropagation();
        confirmationDialog(evt);
      },
      { capture: true },
      true
    );
  });
}

export function removeVisibleTooltips() {
  document
    .querySelectorAll(`.tooltip[role="tooltip"]`)
    .forEach(el => el.remove());
}

function setUpModal() {
  const modal = document.querySelector("#modal");
  const modalInstance = Modal.getOrCreateInstance(modal);
  function hiddenCallback() {
    const modalContent = modal.querySelector("#modalContent");
    if (!modalContent) return;
    Array.from(modalContent.children).forEach(el => el.remove());
  }
  modal.addEventListener("hidden.bs.modal", hiddenCallback);
  const domObserver = new MutationObserver(mutationList => {
    for (const mutation of mutationList) {
      for (const node of mutation.addedNodes) {
        if (node.name === "modalClose") {
          // If found input with that value in name attribute, then close modal automatically
          modalInstance.hide();
        } else if (node.name === "modalOpen") {
          // Or if its this value, then automatically open
          modalInstance.show();
        }
      }
    }
  });
  const modalContent = modal.querySelector("#modalContent");
  if (!modalContent) {
    modal.removeEventListener(hiddenCallback);
    return;
  }
  // Observe modal's content for input with name="closeModal"
  domObserver.observe(modalContent, { childList: true });
}

function setupScrollUp() {
  // Element that when hidden from view makes "scroll up" button shown
  const scrollBtnTigger = document.querySelector("#scrollBtnObserver");
  scrollBtnTigger.classList.add("scroll-observer");

  const scrollbtn = document.querySelector(".scroll-up");
  new IntersectionObserver(function (entries) {
    if (entries[0].intersectionRatio <= 0) {
      // When "#scrollBtnObserver" is no longer "visible" in browser
      scrollbtn.classList.remove("d-none");
    } else {
      // When "#scrollBtnObserver" is "visible" in browser again
      scrollbtn.classList.add("d-none");
    }
  }).observe(scrollBtnTigger);

  scrollbtn.addEventListener("click", () => {
    window.scrollTo(0, 0);
  });
}

export function initTooltips() {
  document.querySelectorAll(`[data-bs-toggle="tooltip"]`).forEach(el => {
    new Tooltip(el);
  });
}

function setSessionMessage() {
  const notice = sessionStorage.getItem("notice");
  const alert = sessionStorage.getItem("alert");
  if (notice) {
    sessionStorage.removeItem("notice");
    const noticeBox = document.querySelector("#noticeAlert");
    noticeBox.innerText = notice;
    noticeBox.classList.remove("d-none");
  }
  if (alert) {
    sessionStorage.removeItem("alert");
    const alertBox = document.querySelector("#alertAlert");
    alertBox.innerText = alert;
    alertBox.classList.remove("d-none");
  }
}
